<template>
  <TFinderLayout>
    <template #sidebar>
      <div v-if="$vuetify.breakpoint.smAndUp" class="color-white-04">Help Center</div>

      <TFlex
        v-for="(option, index) in options"
        :key="`option#${index}:${option.name}`"
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: option.name
          })"
      >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === option.name"
          class="help-sidebar-highlight"
        />
        <div
          class="help-sidebar-option"
          :style="`padding-right: ${$vuetify.breakpoint.smAndUp ? 16 : 0}px;`"
        >
          <v-icon class="color-white-09 mr-1" :small="$vuetify.breakpoint.smAndUp">{{ option.icon }}</v-icon>
          <TText
            v-if="$vuetify.breakpoint.smAndUp"
            :value="option.name"
            font_weight="400"
            medium
          />
        </div>
      </TFlex>
    </template>
    <template #content>
      <router-view/>
    </template>
  </TFinderLayout>
</template>

<script>
import { TFinderLayoutMixin } from '@/mixins/TFinderLayout.mixin.js';
import TText from '@/components/Taktify/TText.component.vue';

export default {
  name: 'Account',

  components: {
    TText,
  },

  mixins: [
    TFinderLayoutMixin,
  ],

  data: () => ({
    options: [
      { name: 'FAQ', icon: 'quiz' },
      { name: 'Tutorials', icon: 'movie' },
      { name: 'Contact', icon: 'person' },
      { name: 'Examples', icon: 'difference' },
      { name: 'Fun', icon: 'casino' },
    ],
  }),
}
</script>
<style lang="scss" scoped>
.help-sidebar-highlight {
  margin-left: -10px;
  height: 24px;
  width: 2px;
  position: absolute;
  background-color: rgba(255,255,255,0.9);
}
.help-sidebar-option {
  position: relative;
  display: flex;
}
</style>
